// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'


import { Locale } from 'vant';
import enUS from 'vant/es/locale/lang/en-US';
import zhCN from 'vant/es/locale/lang/zh-CN';
import jaJP from 'vant/es/locale/lang/ja-JP';
import {i18n, vantLocales} from './i18n/langs'

vantLocales(i18n.locale);

import router from './router'
import './assets/css/common.css'
import * as echarts from 'echarts'
import BaiduMap from 'vue-baidu-map-v3'
import api from './api/index.js';
import axios from 'axios'
import ba from 'vue-ba'
import {
    Col,
    Row,
    Form,
    Field,
    Checkbox,
    CheckboxGroup,
    Tab,
    Tabs,
    Badge,
    Skeleton,
    Sticky,
    Icon,
    Popup,
    Button,
    Progress,
    Swipe,
    SwipeItem,
    Circle,
    ActionSheet,
    Dialog,
    Overlay,
    Picker,
    Uploader,
    Calendar,
    Cell,
    CellGroup,
    DatetimePicker,
    Switch,
} from 'vant';

Vue.use(Col);
Vue.use(Row);
Vue.use(Form);
Vue.use(Field);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Badge);
Vue.use(Skeleton);
Vue.use(Sticky);
Vue.use(Icon);
Vue.use(Popup);
Vue.use(Button);
Vue.use(Progress);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Circle);
Vue.use(ActionSheet);
Vue.use(Dialog);
Vue.use(Overlay);
Vue.use(Picker);
Vue.use(Uploader);
Vue.use(Calendar);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(DatetimePicker);
Vue.use(Switch);
// import Vant from 'vant';
// import 'vant/lib/index.css';
import 'amfe-flexible/index.js'
import Vconsole from 'vconsole'


// new Vconsole()

import eruda from "eruda/eruda";
// eruda.init();

import Bridge from './utils/JSBridge.js'
import de from "element-ui/src/locale/lang/de";

Vue.prototype.$bridgeObj = Bridge


// Vue.use(Vant);

Vue.use(ba, {siteId: 'fa10145adf08e28d5af43c77b05027fc'})

Vue.use(api);
Vue.use(BaiduMap, {
    ak: '6jzLSpgHspsa3juH8HmlgPq4k27Ejm2z',
    type: 'WebGL'
})
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'
Vue.use(ElementUI, {locale})

router.beforeEach((to, from, next) => {
    if (to.query.theme) {
        document.documentElement.setAttribute("theme", to.query.theme);
    } else {
        document.documentElement.setAttribute("theme", "light");
    }
    if (to.query.token) {
        localStorage.setItem("token", to.query.token);
    }
    if (to.query.lang) {
        if (to.query.lang === 'en') {
            Locale.use('en-US', enUS);
        }
        if (to.query.lang === 'zh') {
            Locale.use('zh-CN', zhCN);
        }
        if (to.query.lang === 'ja') {
            Locale.use('ja-JP', jaJP);
        }
        i18n.locale = to.query.lang;
        to.meta && (document.title = i18n.t(to.meta.title));
    } else {
        i18n.locale = 'zh';
        to.meta && (document.title = i18n.t(to.meta.title));
    }
    const vm = new Vue();
    vm.$root.activeText = to.name;
    next();
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    axios,
    i18n,
    components: {App},
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js